import * as React from "react";
import WalletP2pContainer from "app/components/AppComponents/Fraud/WalletP2pContainer";
import DatePicker from "material-ui/DatePicker";
import * as moment from "moment-timezone";
import { Button } from "@material-ui/core";
import PosConsoleApi from "app/utils/PosConsoleApi";

type Props = {
  setHeader: (data: { title: string; description: string }) => void;
};

type State = {
  filterDate: Date;
  addingKeywords: boolean;
  removingKeywords: boolean;
};

export default class WalletP2p extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);

    const filterDate = new Date();
    filterDate.setDate(filterDate.getDate() - 1);

    this.state = {
      filterDate,
      addingKeywords: false,
      removingKeywords: false,
    };
  }

  addKeywords(event: any) {
    if (!event.target.files[0]) {
      return;
    }
    this.setState({ addingKeywords: true });
    const params: any = {
      csv: event.target.files[0],
    };
    PosConsoleApi.postMultipart("keyword/p2p/add", params)
      .then((response) => {
        this.setState({
          addingKeywords: false,
        });
        return response.json();
      })
      .then((json) => alert(json.message))
      .catch((error) => {
        this.setState({
          addingKeywords: false,
        });
        alert(error);
      })
      .finally(() => (event.target.value = null));
  }

  removeKeywords(event: any) {
    if (!event.target.files[0]) {
      return;
    }
    this.setState({ removingKeywords: true });
    const params: any = {
      csv: event.target.files[0],
    };
    PosConsoleApi.postMultipart("keyword/p2p/remove", params)
      .then((response) => {
        this.setState({
          removingKeywords: false,
        });
        return response.json();
      })
      .then((json) => alert(json.message))
      .catch((error) => {
        this.setState({
          removingKeywords: false,
        });
        alert(error);
      })
      .finally(() => (event.target.value = null));
  }

  componentDidMount() {
    this.props.setHeader({
      title: "Fraud > Wallet P2P",
      description: "P2P wallet transactions",
    });
  }

  fromAndToForDate = (date: Date) => {
    const from = moment(date).startOf("day").tz("Africa/Johannesburg").format();
    const to = moment(date)
      .add(1, "day")
      .startOf("day")
      .tz("Africa/Johannesburg")
      .format();

    return { from, to };
  };

  render() {
    const name = "fraud.walletp2p";
    const fromAndToDate = this.fromAndToForDate(this.state.filterDate);

    return (
      <section style={{ display: "flex" }} className="padded">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <DatePicker
            name={`${name}.datefilter`}
            onChange={(e, date) => {
              this.setState({ filterDate: date });
            }}
            defaultDate={this.state.filterDate}
            style={{ flex: "0 0 auto", alignSelf: "center" }}
          />
          <div
            style={{ flex: "0 0 auto", alignSelf: "center", display: "flex" }}
          >
            <div style={{ margin: "auto 0.5em" }}>
              <input
                accept="text/csv"
                style={{ display: "none" }}
                id="remove-keyword-csv-upload"
                type="file"
                onChange={(event) => this.removeKeywords(event)}
              />
              <label htmlFor="remove-keyword-csv-upload">
                <Button
                  color="secondary"
                  variant="contained"
                  id="remove-keyword-csv-upload"
                  component="span"
                  disabled={this.state.removingKeywords}
                >
                  {this.state.removingKeywords
                    ? "Uploading..."
                    : "Remove keywords"}
                </Button>
              </label>
            </div>
            <div style={{ margin: "auto 0.5em" }}>
              <input
                accept="text/csv"
                style={{ display: "none" }}
                id="add-keyword-csv-upload"
                type="file"
                onChange={(event) => this.addKeywords(event)}
              />
              <label htmlFor="add-keyword-csv-upload">
                <Button
                  color="secondary"
                  variant="contained"
                  id="add-keyword-csv-upload"
                  component="span"
                  disabled={this.state.addingKeywords}
                >
                  {this.state.addingKeywords ? "Uploading..." : "Add keywords"}
                </Button>
              </label>
            </div>
          </div>
        </div>
        <WalletP2pContainer name={name} filterDate={fromAndToDate} />
      </section>
    );
  }
}
